import { put, call, all, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/accountStatement'
import {
  getCustomerAccounts,
  getAccountStatementReport as getStatementReport,
  getAccountStatementDownload as getStatementDownload
} from 'services'

import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { REQUEST_ERROR } from 'config/messages'
import DOWNLOAD_TYPE from 'utils/downloadType'

const {
  ACCOUNT_STATEMENT_REQUEST,
  ACCOUNT_STATEMENT_SUCCESS,
  ACCOUNT_STATEMENT_ERROR,
  ACCOUNT_STATEMENT_REPORT_REQUEST,
  ACCOUNT_STATEMENT_REPORT_SUCCESS,
  ACCOUNT_STATEMENT_REPORT_ERROR,
  ACCOUNT_STATEMENT_DOWNLOAD_REQUEST,
  ACCOUNT_STATEMENT_DOWNLOAD_SUCCESS,
  ACCOUNT_STATEMENT_DOWNLOAD_ERROR,
  ACCOUNT_STATEMENT_SET_NO_CONTENT
} = ACTION_TYPES

export function *getAccountStatement() {
  try {
    const response = yield call(getCustomerAccounts)
    yield put({ type: ACCOUNT_STATEMENT_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: ACCOUNT_STATEMENT_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *getAccountStatementReport(payload) {
  try {
    const response = yield call(getStatementReport, payload)
    if (response.status === 200) {
      yield put({ type: ACCOUNT_STATEMENT_REPORT_SUCCESS, payload: response })
    } else if (response.status === 204) {
      yield put({ type: ACCOUNT_STATEMENT_REPORT_ERROR, payload: response })
      yield put({ type: ACCOUNT_STATEMENT_SET_NO_CONTENT })
    }
  } catch (err) {
    yield put({ type: ACCOUNT_STATEMENT_REPORT_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *getAccountStatementDownload({ payload }) {
  try {
    let format
    let fileName
    switch (payload.format) {
      case DOWNLOAD_TYPE.REQUEST_TYPE.pdf:
        format = DOWNLOAD_TYPE.RESPONSE_TYPE['application/pdf']
        fileName = `Extrato_${payload.endDate}.pdf`
        break
      default:
        format = DOWNLOAD_TYPE.RESPONSE_TYPE['text/x-csv']
        fileName = `Extrato_${payload.endDate}.csv`
    }

    const response = yield call(getStatementDownload, { payload })
    yield put({ type: ACCOUNT_STATEMENT_DOWNLOAD_SUCCESS, payload: { response, format, fileName } })
  } catch (err) {
    yield put({ type: ACCOUNT_STATEMENT_DOWNLOAD_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export default function *watchAccountStatement() {
  yield all([
    takeLatest(ACCOUNT_STATEMENT_REQUEST, getAccountStatement),
    takeLatest(ACCOUNT_STATEMENT_REPORT_REQUEST, getAccountStatementReport),
    takeLatest(ACCOUNT_STATEMENT_DOWNLOAD_REQUEST, getAccountStatementDownload)
  ])
}
